import styled, { css } from 'styled-components/macro'
import InputLabel from '@material-ui/core/InputLabel'

export const Wrapper = styled.div`
  width: 100%;
`

export const NomeSecao = styled.h1`
  ${({ theme }) => css`
    color: ${theme.colors.black};
    font-weight: ${theme.font.bold};
    font-size: ${theme.font.sizes.medium};
  `}
  margin-bottom: 16px;
`

export const Label = styled(InputLabel)`
  margin-bottom: 8px;
`

export const Divisor = styled.div`
  height: 1px;
  margin: 32px 0;
  ${({ theme }) => css`
    background-color: ${theme.colors.lightGray};
  `}
`
